module.exports = "<!-- Render sub-components within this component. -->\n<div *ngIf=\"isVisible()\">\n  <ng-content></ng-content>\n</div>\n"